var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg250Ml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#47464A",
    fillRule: "evenodd",
    d: "M43.993 9H20c-1.654 0-3 1.346-2.999 3.05l1.999 39.941c0 1.654 1.345 3 2.999 3h19.996c1.653 0 3-1.346 2.999-2.95l2-39.992V12c0-1.653-1.346-2.999-3-2.999zm-.999 42.991c0 .551-.448 1-1 1H21.998c-.552 0-1-.449-1.001-1.05l-.147-2.949h22.294l-.15 3zm.25-4.999H20.75L19.573 23.45c.03.01.061.017.09.025.164.049.322.102.478.156.065.022.132.043.195.066.213.076.424.155.637.235 1.394.524 2.836 1.065 5.684 1.065 2.853 0 4.295-.54 5.69-1.063 1.284-.48 2.497-.935 4.978-.935 2.487 0 3.7.454 4.985.936.264.099.535.197.813.294.081.029.166.056.25.084.299.099.61.194.952.279l.037.01-1.119 22.391zm1.22-24.438a12.366 12.366 0 0 1-.601-.187c-.07-.024-.144-.047-.213-.072a35.694 35.694 0 0 1-.639-.234c-1.394-.523-2.837-1.063-5.686-1.063-2.844 0-4.285.54-5.68 1.062-1.285.482-2.498.938-4.988.938-2.486 0-3.697-.457-4.98-.938a48.74 48.74 0 0 0-.574-.214l-.181-.064a13.27 13.27 0 0 0-.683-.223 12.857 12.857 0 0 0-.573-.159l-.143-.037c-.017-.003-.034-.01-.052-.013L18.999 12a1 1 0 0 1 1-1h23.994c.545 0 .988.437 1 .978l-.528 10.576z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg250Ml);
export default __webpack_public_path__ + "static/media/250_ml.95ae8cd877cd0841d2d17e7e85aa8001.svg";
export { ForwardRef as ReactComponent };